import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=c3654e36&scoped=true&"
import script from "./SelectBox.vue?vue&type=script&lang=ts&"
export * from "./SelectBox.vue?vue&type=script&lang=ts&"
import style0 from "./SelectBox.vue?vue&type=style&index=0&id=c3654e36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3654e36",
  null
  
)

export default component.exports